/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      const box = document.getElementById( 'dvd' );
      const colors = ['#ff0000', '#ff4000', '#ff8000', '#ffbf00', '#ffff00', '#bfff00', '#80ff00', '#40ff00', '#00ff00', '#00ff40', '#00ff80', '#00ffbf', '#00ffff', '#00bfff', '#0080ff', '#0040ff', '#0000ff', '#4000ff', '#8000ff', '#bf00ff', '#ff00ff', '#ff00bf', '#ff0080', '#ff0040', '#ff0000'];
      let currentColor = Math.floor( ( Math.random() * 25 ) + 1 );
      const win = window;
      const ww = win.innerWidth;
      const wh = win.innerHeight;
      let translateX = Math.floor( ( Math.random() * ww ) + 1 );
      let translateY = Math.floor( ( Math.random() * wh ) + 1 );
      const boxWidth = box.offsetWidth;
      const boxHeight = box.offsetHeight;
      const boxTop = box.offsetTop;
      const boxLeft = box.offsetLeft;
      let xMin = -boxLeft;
      let yMin = -boxTop;
      let xMax = win.innerWidth - boxLeft - boxWidth;
      let yMax = win.innerHeight - boxTop - boxHeight;
      let request = null;
      let direction = 'se';
      const speed = 4;
      let timeout = null;

      init();

      // reset constraints on resize
      window.addEventListener( 'resize', function( argument ) {
        clearTimeout( timeout );
        timeout = setTimeout( update, 100 );
      }, false );

      function init() {
        request = requestAnimationFrame( init );
        move();
        // setInterval(function() {
        //   move();
        // }, 16.66);
      }

      // reset constraints
      function update() {
        xMin = -boxLeft;
        yMin = -boxTop;
        xMax = win.innerWidth - boxLeft - boxWidth;
        yMax = win.innerHeight - boxTop - boxHeight;
      }

      function move() {
        setDirection();
        setStyle( box, {
          transform: 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0)',
        } );
      }

      function setDirection() {
        switch ( direction ) {
          case 'ne':
            translateX += speed;
            translateY -= speed;
            break;
          case 'nw':
            translateX -= speed;
            translateY -= speed;
            break;
          case 'se':
            translateX += speed;
            translateY += speed;
            break;
          case 'sw':
            translateX -= speed;
            translateY += speed;
            break;
        }
        setLimits();
      }

      function setLimits() {
        if ( translateY <= yMin ) {
          if ( direction == 'nw' ) {
            direction = 'sw';
          } else if ( direction == 'ne' ) {
            direction = 'se';
          }
          switchColor();
        }
        if ( translateY >= yMax ) {
          if ( direction == 'se' ) {
            direction = 'ne';
          } else if ( direction == 'sw' ) {
            direction = 'nw';
          }
          switchColor();
        }
        if ( translateX <= xMin ) {
          if ( direction == 'nw' ) {
            direction = 'ne';
          } else if ( direction == 'sw' ) {
            direction = 'se';
          }
          switchColor();
        }
        if ( translateX >= xMax ) {
          if ( direction == 'ne' ) {
            direction = 'nw';
          } else if ( direction == 'se' ) {
            direction = 'sw';
          }
          switchColor();
        }
      }

      function switchColor() {
        let color = Math.floor( ( Math.random() * 25 ) + 1 );

        while ( color == currentColor ) {
          color = Math.floor( ( Math.random() * 25 ) + 1 );
        }

        setStyle( box, {
          color: colors[color],
        } );

        currentColor = color;
      }

      function getVendor() {
        const ua = navigator.userAgent.toLowerCase();
        const match = /opera/.exec( ua ) || /msie/.exec( ua ) || /firefox/.exec( ua ) || /(chrome|safari)/.exec( ua ) || /trident/.exec( ua );
        const vendors = {
          opera: '-o-',
          chrome: '-webkit-',
          safari: '-webkit-',
          firefox: '-moz-',
          trident: '-ms-',
          msie: '-ms-',
        };

        return vendors[match[0]];
      }

      function setStyle( element, properties ) {
        const prefix = getVendor();
        let property; let css = '';
        for ( property in properties ) {
          if ( property ) {
            css += property + ': ' + properties[property] + ';';
            css += prefix + property + ': ' + properties[property] + ';';
          }
        }
        element.style.cssText += css;
      }

      setTimeout( function() {
        $( '.loader' ).fadeOut();
      }, 3000 );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'loader', COMPONENT );
} )( app );
